import {filterWrapperBasicTypes} from '@adv-mt/mt-filter-wrapper-basic'

export const WRAPPERS_BY_DESIGN = {
  modalPopover: filterWrapperBasicTypes.MODAL_POPOVER_WITH_SEARCH_BAR
}
